import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialGoogleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M4.00501 12.0102C3.84512 7.88565 7.53255 4.07406 11.7466 4.0246C13.8944 3.84512 15.984 4.66229 17.6094 5.99507C16.9426 6.71333 16.2642 7.4233 15.5396 8.08796C14.1087 7.23621 12.3858 6.58711 10.7135 7.16359C8.01611 7.91608 6.38259 11.0364 7.38078 13.6217C8.20742 16.3219 11.5595 17.8037 14.1867 16.6694C15.547 16.1922 16.4439 14.9625 16.8374 13.6411C15.2784 13.6107 13.719 13.6297 12.1599 13.5875C12.156 12.6787 12.1522 11.7733 12.156 10.8645C14.756 10.8607 17.3598 10.8531 19.9636 10.8759C20.1235 13.1027 19.7882 15.4857 18.3107 17.2729C16.2875 19.824 12.5496 20.5726 9.50881 19.5719C6.28164 18.5334 3.93477 15.348 4.00501 12.0102Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
